"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxGroup = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListboxGroupMixin = require("../../mixins/components/ListboxGroupMixin");
/**
 * A group of `Listbox` options, similar to a select `<optgroup>`.
 *
 * @since 8.28.0
 */
var ListboxGroup = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "ListboxGroup",
  componentId: "c11n-8-109-1__sc-1a0j08-0"
})(["", ""], _ListboxGroupMixin.ListboxGroupMixin);
exports.ListboxGroup = ListboxGroup;
ListboxGroup.displayName = 'ListboxGroup';
ListboxGroup.propTypes = {
  /**
   * https://www.w3.org/TR/wai-aria-1.2/#aria-labelledby
   */
  'aria-labelledby': _propTypes.default.string.isRequired,
  /**
   * Uses the ["group"](https://www.w3.org/TR/wai-aria-1.2/#group) role by default.
   */
  'role': _propTypes.default.string
};
ListboxGroup.defaultProps = {
  role: 'group'
};

/** @component */